module.exports = "/images/SuppImg1.jpg";